export default "__VITE_ASSET__CYnYIbfL__"